import { Endpoints } from '@/core/models/endpoints.interface';

export const SYSTEM_NOTIFICATIONS_ENDPOINTS: Pick<Endpoints, 'GET'> = {
   GET: () => '/system-notification',
};
